<footer class="top-footer">

    <div class="container pt-4 pb-4">
        <div class="row">
            <div class="col logo px-4">
                <img src="assets/images/concytec.png" alt="logo"/>
            </div>
            <div class="col contact px-4">

                <span class="d-block"><strong>{{ 'footer.contact.name' | translate }}</strong></span>
                <span class="d-block">{{ 'footer.contact.address' | translate }}</span>
                <span class="d-block">{{ 'footer.contact.city' | translate }}</span>
                <span class="d-block">{{ 'footer.contact.tel' | translate }}</span>
                <span class="d-block"><strong>{{ 'footer.contact.email' | translate }}</strong></span>

            </div>
            <div class="col actions px-4">
                <div class="d-flex">
                    <a class="text-white mr-2" href="#" (click)="showCookieSettings()"><span>{{ 'footer.link.cookies' | translate}}</span></a>
                    <a class="text-white mr-2" routerLink="info/end-user-agreement">{{ 'footer.link.terms-of-use' | translate }}</a>
                    <a class="text-white" href="https://sites.google.com/concytec.gob.pe/manual-visitante-perucris" target="_blank">{{ 'footer.link.visitor-handbook' | translate }}</a>
                </div>
            </div>
        </div>
    </div>

</footer>
